import { render, staticRenderFns } from "./HeroSliderAdmin.vue?vue&type=template&id=bef80c1c&scoped=true"
import script from "./HeroSliderAdmin.vue?vue&type=script&lang=js"
export * from "./HeroSliderAdmin.vue?vue&type=script&lang=js"
import style0 from "./HeroSliderAdmin.vue?vue&type=style&index=0&id=bef80c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef80c1c",
  null
  
)

export default component.exports